import type { LabelAssignmentTargetSearchResult } from '../../assignedLabelsTypes';

export type GroupedInterfaceTargets = {
  deviceSn: string;
  hostname: string | null;
  interfaces: Array<{
    interfaceName: string;
    snapshotCount: number;
  }>;
};

export const groupInterfaceTargetsByDevice = (
  results: LabelAssignmentTargetSearchResult[],
): GroupedInterfaceTargets[] => {
  const groups = new Map<string, GroupedInterfaceTargets>();

  for (const result of results) {
    if (result.type !== 'intL2') {
      continue;
    }

    const existing = groups.get(result.sn);
    if (existing) {
      existing.interfaces.push({
        interfaceName: result.interfaceName,
        snapshotCount: result.snapshotCount,
      });
      continue;
    }

    groups.set(result.sn, {
      deviceSn: result.sn,
      hostname: result.hostname,
      interfaces: [
        {
          interfaceName: result.interfaceName,
          snapshotCount: result.snapshotCount,
        },
      ],
    });
  }

  return [...groups.values()];
};

export const applyInterfaceFilter = (
  groups: GroupedInterfaceTargets[],
  interfaceFilter: string,
): GroupedInterfaceTargets[] => {
  if (!interfaceFilter) {
    return groups;
  }

  const needle = interfaceFilter.toLowerCase();
  return groups
    .map((group) => ({
      ...group,
      interfaces: group.interfaces.filter((iface) =>
        iface.interfaceName.toLowerCase().includes(needle),
      ),
    }))
    .filter((group) => group.interfaces.length > 0);
};
